import React, { FC, ReactNode } from 'react';
const OfferDescriptionAndTitle: FC<{ children?: ReactNode }> = ({
  children,
}) => {
  return (
    <div className="flex justify-start mb-10 items-start md:mb-none relative Offer-Info-Wrapper">
      {children}
    </div>
  );
};

export default OfferDescriptionAndTitle;
